import { Rule } from 'antd/lib/form';
import FormInput from 'components/Input/FormInput';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import style from './TlsCertificateNameField.module.scss';

interface IProps {
	changeTlsCertificateName: (value: string) => void;
	tlsCertificateFileId: Nullable<string>;
}

export const TlsCertificateNameField: React.FC<IProps> = ({ changeTlsCertificateName, tlsCertificateFileId }) => {
	const { t } = useTranslation('error');

	const validationRules = useMemo<Rule[]>(
		() => [
			() => ({
				validator(_, value) {
					if (tlsCertificateFileId && !value) {
						return Promise.reject(new Error(t('enterTlsCertificateName')));
					}
					return Promise.resolve();
				},
			}),
		],
		[t, tlsCertificateFileId],
	);

	return (
		<FormInput
			testId="TlsCertificateNameField"
			name="tlsCertificateName"
			label="tlsCertificateNameLabel"
			containerClassName={style.container}
			maxLength={50}
			onChange={changeTlsCertificateName}
			validationRules={validationRules}
		/>
	);
};
